import { useState, useEffect } from 'react';
import { Button, Select } from 'antd';
import ManageRoleModal from './ManageRoleModal';

const CreateSelectRole = ({
    data,
    setCurrentRoleUniqueId,
    setDrawRolePermission,
    setCurrentRole,
    drawRolePermission
}) => {
    const [rolesData, setRolesData] = useState(data);
    const [manageRoleModalVisible, setManageRoleModalVisibility] = useState(false);

    useEffect(() => {
        if (data) {
            setRolesData(data);
        }
    }, [data]);

    return  <>
                <ManageRoleModal
                    visible={manageRoleModalVisible}
                    rolesData={rolesData}
                    setRolesData={setRolesData}
                    setManageRoleModalVisibility={setManageRoleModalVisibility}
                    setDrawRolePermission={setDrawRolePermission}
                    drawRolePermission={drawRolePermission}
                    closable={true}
                    onCancel={() => setManageRoleModalVisibility(false)}
                    maskClosable={false}
                    destroyOnClose
                />
                <label>Role:</label>&nbsp;&nbsp;
                <Select
                    placeholder='Select role'
                    style={{
                        width: '350px'
                    }}
                    onChange={(value, option) => {
                        setCurrentRoleUniqueId(value);
                        setCurrentRole(option.role);
                    }}
                >
                    {rolesData 
                        && rolesData.length > 0 
                        && rolesData.map(dataRole => (
                        <Select.Option 
                            key={dataRole.uniqueId} 
                            value={dataRole.uniqueId}
                            role={dataRole}
                        >
                            {dataRole.role}
                        </Select.Option>
                    ))}
                </Select>&nbsp;&nbsp;
                <Button
                    onClick={() => setManageRoleModalVisibility(true)}
                >
                    New Role
                </Button>
            </>;
};

export default CreateSelectRole;
